import { APIClient } from "../helpers/api_helper";
import * as url from "../helpers/url_helper";

const api = new APIClient();

export const getDashboarDataService = () => {
  return api.get(url.DASHBOARD_DATA);
};

export const getDashboarBillingDataService = (id) => {
  return api.get(url.DASHBOARD_BILLING_DATA(id));
};
